import { PagedBoard } from "../../platform/ui/PagedBoard";
import { PageShell } from "../../platform/ui/PageShell";
import { StateMessage } from "../../platform/ui/StateMessage";
import { usePagedList } from "../../platform/async/usePagedList";
import { routes } from "../../app/routes";
import { fetchPosts } from "./blog-api";
import { PostCard } from "./PostCard";
import "./blog.css";

export function BlogPage() {
  const posts = usePagedList(fetchPosts);

  return (
    <PageShell
      eyebrow="Written by Orla"
      title="Orla's Blog"
      lead="What I am working on, what went wrong, and what I learned from it."
      layout="viewport"
    >
      {posts.items.length > 0 ? (
        <PagedBoard
          items={posts.items}
          getKey={(post) => post.slug}
          renderItem={(post) => <PostCard post={post} />}
          canFetchMore={posts.nextCursor !== null && posts.status === "ready"}
          fetching={posts.status === "loading_more"}
          onFetchMore={posts.loadMore}
          label="Posts"
          newerLabel="Newer"
          olderLabel="Older"
          itemMinWidthRem={18}
          itemMinHeightRem={10.5}
          maxColumns={2}
        />
      ) : (
        <div className="blog-state" data-slot="stage">
          {posts.status === "loading" ? (
            <StateMessage tone="loading" title="Fetching posts" />
          ) : null}
          {posts.status === "failed" ? (
            <StateMessage
              tone="error"
              title="The blog could not be loaded"
              action={{ label: "Try again", onSelect: posts.reload }}
            >
              {posts.error?.message}
            </StateMessage>
          ) : null}
          {posts.status === "ready" ? (
            <StateMessage tone="empty" title="Nothing published yet">
              Orla has not published a post yet. When she does, it will appear here and in the feed.
            </StateMessage>
          ) : null}
        </div>
      )}
      {posts.status === "failed_more" ? (
        <StateMessage
          tone="error"
          title="Older posts could not be loaded"
          action={{ label: "Try again", onSelect: posts.loadMore }}
        >
          {posts.error?.message}
        </StateMessage>
      ) : null}
      <p className="blog-feed">
        <a href={routes.feed()}>Follow by RSS</a>
      </p>
    </PageShell>
  );
}
